import React from "react"
import { motion } from "framer-motion"
import "./about.css"

const AboutCard = () => {
  return (
    <section className='md-message-section'>
      <div className='container'>
        <div className='md-grid'>
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className='md-image-container'
          >
            <div className='md-image-glow'></div>
            <img src='/images/aboutimg.jpg' alt='MD Office' className='md-photo' />
            <div className='md-signature-box'>
              <h4 className='md-name'>Dr. Ram Krishan Sharma</h4>
              <p className='md-title'>Managing Director</p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className='md-content'
          >
            <span className='md-badge'>Leadership Vision</span>
            <h2 className='md-heading'>Shaping <span className='text-gradient'>Future-Ready</span> Learners</h2>

            <div className='md-text-wrapper'>
              <p>
                As someone with a background in Arts and a Bachelor of Education, I have always believed that education is about nurturing the whole person—mind, heart, and character.
              </p>
              <p>
                The Curriculum for Welsh is built on four clear purposes: to develop learners who are ambitious, capable, enterprising, and creative. These aren't just goals—they're the foundation for helping our young people grow into successful individuals and responsible citizens.
              </p>
              <p>
                Our mission is to advance education by embracing innovation, inclusivity, and excellence. We aim to expand horizons for our students, opening doors to new opportunities and preparing them to thrive in a diverse, interconnected world.
              </p>
              <p>
                At its core, Welsh education is shaping minds not just for today's challenges, but for tomorrow's possibilities. I invite you to be part of this journey—with us, in Welsh.
              </p>
            </div>

            <div className='md-footer-branding'>
              <img src='/logo.svg' alt='Welsh Logo' className='mini-logo' />
              <div className='branding-text'>
                <h5 className='text-gradient'>WELSH EDUCATION GROUP</h5>
                <p>Excellence in Global Consultancy</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default AboutCard
